import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MainService } from '../../../services/main/main.service';
import { AuthService } from '../../../services/auth/auth.service';
import { AbstractControl, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  environment: any = localStorage.getItem('environment') || '';

  user = this.fb.group({
    newPassword: ["", [Validators.required, this.passwordPolicyValidator()]],
    confirmPassword: ["", Validators.required],
  }, { validator: this.matchPassword });
  passwordPolicyContainer: boolean = false;
  realValue: string = '';
  realValueConfirm: string = '';
  @ViewChild('passwordContainer',{static: false}) passwordContainer : ElementRef;
  constructor(
    public mainService: MainService,
    public authService: AuthService,
    public fb: UntypedFormBuilder,
    public router:Router
  ) { }

  ngOnInit() {
  }

  submitForm(form: any) {
    if (form.value.newPassword != form.value.confirmPassword) {
      this.mainService.customPopups('Passwords did not match', 2);
      return false;
    }

    if (form.value.newPassword.length < 6) {
      this.mainService.customPopups('Passwords must contain at least 6 characters', 2);
      return false;
    }

    if (!form.value.newPassword || form.value.newPassword.trim().length == 0) {
      this.mainService.customPopups('Enter a valid password', 2);
      return false;
    }

    let params = {
      reset_password_token: localStorage.getItem('reset_password_token'),
      email: localStorage.getItem('reset_email').replace(/\s/g, '').toLowerCase(),
      new_password: this.mainService.encryptInMD5(form.value.newPassword),
      device_type: environment.device_type,
      app_type: environment.app_type,
      device_token: environment.device_token,
      app_version: environment.app_version,
      device_id: localStorage.getItem('user')
    };

    this.mainService.api(params, "change_password", false)
      .subscribe((data: any) => {
        this.mainService.flagPopUps(data.flag, data.is_error)
        if (data.is_error == 0) {
          localStorage.removeItem('reset_password_token');
          localStorage.getItem('reset_email');
          /*setting side menu once user logged in and got side menu data*/
          if (data.menu) {
            this.mainService.available_menu.next(data.menu);
            this.mainService.flagPopUps(data.flag, '');
            this.authService.setLoginData(data);
            this.authService.accessTokenLogin();
            this.mainService.init();
          } else {
            this.mainService.flagPopUps(1, 'We got some critical issues while login. Please contact Administrator.');
          }
        }
      }, (error: any) => {
        console.log(error);
      })
  }

  call_me(){
    localStorage.removeItem('token')
    this.router.navigate(["/login"]);
  }

  matchPassword(control: AbstractControl): ValidationErrors | null {
    const password = control.get("newPassword").value;
    const confirm = control.get("confirmPassword").value;
    if (password != confirm) { return { 'noMatch': true } }
    return null
  }

  passwordPolicyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const errors: ValidationErrors = {};

    if (value.length < 8) {
      errors['minLength'] = true;
    }
    if (!/[a-z]/.test(value)) {
      errors['lowercase'] = true;
    }
    if (!/[A-Z]/.test(value)) {
      errors['uppercase'] = true;
    }
    if (!/\d/.test(value)) {
      errors['number'] = true;
    }
    if (!/[!@#$%^&*]/.test(value)) {
      errors['specialChar'] = true;
    }
    if(value && value[value.length-1] == ' '){
      errors['trailingspace'] =true;
    }

    return Object.keys(errors).length ? errors : null;
    };
  }

  showPasswordPolicyContainer(){
    this.passwordPolicyContainer = true;
  }
  hidePasswordPolicyContainer(){
    this.passwordPolicyContainer = false;
    if(this.user.controls.newPassword.touched && this.user.controls.newPassword.errors && this.user.controls.newPassword.errors.trailingspace){
      this.mainService.customPopups("Please don’t end your password with blank space.",2);
    } 
  }

  get displayedValue(): string {
    return this.showNewPassword ? this.realValue : '•'.repeat(this.realValue.length);
  }

  get displayedValueConfirm(): string {
    return this.showConfirmPassword ? this.realValueConfirm : '•'.repeat(this.realValueConfirm.length);
  }

  handleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    if (this.showNewPassword) {
      this.realValue = newValue;
    } else {
      if (newValue.length < this.realValue.length) {
        this.realValue = this.realValue.slice(0, newValue.length);
      } else {
        const addedText = newValue.slice(this.realValue.length);
        this.realValue += addedText;
      }
    }
    this.user.controls.newPassword.setValue(this.realValue, { emitEvent: true });
  }

  handleInputConfirm(event: Event) {
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    if (this.showConfirmPassword) {
      this.realValueConfirm = newValue;
    } else {
      if (newValue.length < this.realValueConfirm.length) {
        this.realValueConfirm = this.realValueConfirm.slice(0, newValue.length);
      } else {
        const addedText = newValue.slice(this.realValueConfirm.length);
        this.realValueConfirm += addedText;
      }
    }
    this.user.controls.confirmPassword.setValue(this.realValueConfirm, { emitEvent: true });
  }

}
